import { Extension } from "@tiptap/core"
import { Plugin } from "prosemirror-state"

import { isRemoteChange } from "../collaboration/shared-doc"

export const TrailingNode = Extension.create({
	name: "trailingNode",

	addProseMirrorPlugins() {
		return [
			new Plugin({
				appendTransaction: (transactions, __, newState) => {
					if (transactions.every(isRemoteChange)) return null
					const doc = newState.doc
					const lastNode = doc.lastChild

					// Check if the last node is a paragraph, if not, insert a new paragraph
					if (!lastNode || lastNode.type.name !== "paragraph") {
						const paragraphNode = newState.schema.nodes.paragraph
						if (!paragraphNode) {
							console.error("Paragraph node is not defined in the schema.")
							return null
						}

						const tr = newState.tr
						tr.insert(doc.content.size, paragraphNode.create())
						return tr
					}

					return null
				},
			}),
		]
	},
})

export default TrailingNode
